import React from 'react';

const LogOutIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6328 13.2V14C13.6328 16.2091 11.842 18 9.63282 18H6.00123C3.79209 18 2.00123 16.2091 2.00123 14V6C2.00123 3.79086 3.79209 2 6.00123 2H9.63281C11.842 2 13.6328 3.79086 13.6328 6V6.8"
      stroke="#120242"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M16.3158 12.4004L18.1663 10.7459C18.6109 10.3483 18.6109 9.65246 18.1662 9.25492L16.3158 7.60039"
      stroke="#120242"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M18.104 10L7.36719 10"
      stroke="#120242"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default LogOutIcon;
